// extracted by mini-css-extract-plugin
module.exports = {"btn":"ExamCreater_btn_1WoAa","forminput":"ExamCreater_forminput_1K2Du","numberinput":"ExamCreater_numberinput_ZHeYG"};